export default {
    title: "Artículos no entregados",
    header: "@:views.survey.deliveryfaq.title",
    result: {
        header: "Gracias",
        message: "Gracias por tu respuesta."
    },
    message: "Ha indicado que no ha recibido su artículo a pesar de que el mensajero lo marcó como entregado.",
    cta: "Siga estos pasos para ayudarnos a solucionar el problema:",
    items: {
        1: {
            message: "Haga clic en el/los enlace(s) de seguimiento:"
        },
        2: {
            message: "Revisa el estado del envío. Comprueba:",
            items: {
                1: "¿Quién firmó por el paquete?",
                2: "Si fue devuelto al remitente",
                3: "Si el paquete está esperando a ser recogido"
            }
        },
        3: {
            message: "Busque un aviso de entrega que indique dónde pudo haberse dejado el artículo."
        },
        4: {
            message: "Consulte con vecinos, familiares y amigos que puedan haber recogido el paquete."
        }
    },
    question: "¿Te ha ayudado esto a resolver tu consulta sobre la entrega? ¿Ya tienes el artículo o sabes quién lo tiene? Responde a continuación.",
    product: {
        name: "Nombre del artículo",
        quantity: "Cantidad",
        tracking: "Seguimiento",
    },
    buttons: {
        yes: "Sí",
        no: "No",
        saving: "Ahorro"
    }
}